import React from 'react';
import { getSubCategoryId } from '../../../../../utils/DictionaryManagementUtils';
import FullPageSimulator from '../../FullPageSimulator';
import MenuManualRecipient from '../../../../ManulRecipient/MenuManualRecipient';

//= ========================================================================
const ManualRecipientFP = ({
  globJSON,
  selectedScreen,
  simPlatform,
  manualName,
  TopTitle = null,
  headlineText,
  isFormFilled,
  toAddContactName,
  slideshowRefs,

}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);

  return (

    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={headlineText}
      TopTitle={TopTitle}
      slideshowRefs={slideshowRefs}
    >
      <MenuManualRecipient
        globJSON={globJSON}
        simPlatform={simPlatform}
        manualName={manualName}
        subCategoryId={subCategoryId}
        isFormFilled={isFormFilled}
        toAddContactName={toAddContactName}
      />
    </FullPageSimulator>

  );
};

export default ManualRecipientFP;
